<template>
  <div id="mytask-layout" class="theme-indigo wx-login-layout">
    <slot />
  </div>
</template>



<script>

export default {
  name: 'LoginLayout',
};
</script>

<style></style>
